<style scoped lang="less">
	#sector {
		width: 100%;
		min-height: 50vh;
		margin: 0 auto;

		// /deep/ div {
		// 	width: 100% !important;
		// }
	}


	#sxpice {
		width: 100%;
		min-height: 20vh;
		margin: 0 auto;
		
	}

	#sxpople {
		width: 100%;
		height: 20rem;
		margin: 1rem auto;
	}
</style>
<template>
	<div style="width: 100%;">
		<div id="sector" v-if="datetypes=='linear'" ref="sector">
		</div>
		<div id="sxpice" v-if="datetypes=='pie'" ref="sxpice">

		</div>
		<div id="sxpople" v-if="datetypes=='pie1'" ref="sxpople">

		</div>
	</div>
</template>

<script>
	export default {
		props: {
			type: [String, Number],
			datetype: String
		},
		name1: 'sector',
		name2: "sxpice",
		data() {
			return {
				datetypes: this.datetype,


			}
		},
		mounted() {
			
		},
		updated() {

		},
		methods: {},
		watch: {},
		created() {}
	}
</script>
